module.exports = __webpack_public_path__ + "static/media/fundRequest.fc074ad8.png";